// ActivityHistoryCard/fragments/AdaptiveActionBar.tsx
import * as React from 'react';
import { Box } from '@mui/material';
import { FlexyButton } from '@europrocurement/flexy-components/components/atoms';
import { DropdownButton } from '@europrocurement/flexy-components/components/molecules/DropdownButton';
import { useAdaptiveActions, ActionConfig } from '../hooks/useAdaptiveActions';

export interface AdaptiveActionBarProps {
    actions: ActionConfig[];
    dropdownAction?: {
        label: string;
        children: React.ReactNode;
        variant?: 'text' | 'outlined' | 'contained';
        color?: string;
        size?: 'small' | 'medium' | 'large';
        style?: React.CSSProperties;
    };
}

/**
 * Barre d'actions adaptative qui s'ajuste selon la taille d'écran.
 * Utilise les composants FlexyButton et DropdownButton existants.
 */
export const AdaptiveActionBar: React.FunctionComponent<AdaptiveActionBarProps> = function ({
    actions,
    dropdownAction,
}) {
    const { config, adaptedActions } = useAdaptiveActions(actions);

    const flexDirection = config.layout === 'vertical' ? 'column' : 'row';
    const gap = config.layout === 'vertical' ? 0.5 : 1;
    const alignItems = config.layout === 'horizontal' ? 'center' : 'stretch';
    const justifyContent = config.layout === 'horizontal' ? 'end' : 'start';

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection,
                gap,
                alignItems,
                justifyContent,
                flexShrink: 0,
            }}
        >
            {adaptedActions.map((action) => (
                <FlexyButton
                    key={action.id}
                    variant={action.variant || 'text'}
                    size={action.size}
                    onClick={action.onClick}
                    icon={action.icon}
                    label={action.displayLabel}
                    color={action.color}
                />
            ))}

            {dropdownAction && (
                <DropdownButton
                    label={dropdownAction.label}
                    variant={dropdownAction.variant || 'outlined'}
                    size={dropdownAction.size || 'small'}
                    color={dropdownAction.color}
                    style={dropdownAction.style}
                >
                    {dropdownAction.children}
                </DropdownButton>
            )}
        </Box>
    );
};
